import { render, staticRenderFns } from "./EmpleadosSinInventario.view.vue?vue&type=template&id=477e8f58"
import script from "./EmpleadosSinInventario.view.vue?vue&type=script&lang=js"
export * from "./EmpleadosSinInventario.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports